(function (){
    'use strict';

    angular
        .module('services')
        .service('InterestCourseService', InterestCourseService);

    InterestCourseService.$inject = ['$http', 'API_BASE'];

    function InterestCourseService ($http, API_BASE) {
        var service = this;
        service.getAll        = getAll;

        function getAll (query) {
            return $http.get(API_BASE + '/interestCourse/list', {params:query});
        }

    }
})();